<template>
  <el-date-picker
    v-model="timeVal"
    type="daterange"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    prefix-icon="el-icon-time"
    value-format="yyyy-MM-dd"
    :default-value="defaultTime"
    :picker-options="pickerOptions"
    :clearable="clearable">
  </el-date-picker>
</template>

<script>
class baseTodayDay {
  constructor (date, mode) {
    this._date = date
    this._mode = mode
    this._now = new Date()
    this._targetDay = new Date(this._now.getFullYear(), this._now.getMonth(), this._now.getDate() + this._date)
  }

  get StrDay () {
    return this.FormatTime(this._targetDay, this._mode)
  }

  get DateDay () {
    return this._targetDay
  }

  // 时间戳时间
  get TimeDay () {
    return this._targetDay.getTime()
  }

  FormatTime (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
    if (!date) return
    let o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  }
}

const dayMs = 24 * 3600000

export default {
  name: 'MySearchTime',
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultTime: new baseTodayDay(1, 'yyyy-MM-dd').DateDay,
      pickerOptions: {
        disabledDate (time) {
          let limitStartTime = new baseTodayDay(0, 'yyyy-MM-dd').TimeDay
          let limitEndTime = new baseTodayDay(92, 'yyyy-MM-dd').TimeDay
          return time < limitStartTime || time > limitEndTime
        }
      }
    }
  },
  computed: {
    timeVal: {
      set (nv) {
        this.$emit('input', nv)
      },
      get () {
        return this.value
      }
    }
  },
  watch: {
    timeVal ([minDate, maxDate]) {
      if (!minDate || !maxDate) return
      if (new Date(maxDate) - new Date(minDate) > 30 * dayMs) {
        this.$message.warning('时间范围须小于等于31天')
        this.timeVal = []
      }
    }
  },
  created () {
    if (this.timeVal.length === 0) {
      this.getDefaultSection()
    }
  },
  methods: {
    getDefaultSection () {
      this.timeVal = [new baseTodayDay(2, 'yyyy-MM-dd').StrDay, new baseTodayDay(8, 'yyyy-MM-dd').StrDay]
    }
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor {
  position: relative;
  width: 226px;
  height: 38px;
  padding: 8px 0 8px 0px;
  ::v-deep .el-range-separator {
    width: 10%;
    line-height: 22px;
  }
  ::v-deep .el-range__icon {
    font-size: 16px;
    position: absolute;
    top: 2px;
    right: 2px;
  }
}
</style>
